export default "__VITE_ASSET__l$KNX5Al__"